module.exports = __webpack_public_path__ + "static/media/Como.1b4a8367.png";